import React, { ComponentProps } from 'react';
import { Select } from '@myua/kit';
import { useSelector, useDispatch } from 'react-redux';
import * as sortingActions from '../actions';
import { SortingFieldKey, SortingOrder } from '../model';
import { getSortingOrder, getSortingFieldKey } from '../selectors';
import '../styles.scss';
import { getSearchOptions, getSearchUploadData } from '../../search/selectors';

const OPTIONS = [
  { value: 'File name (A-Z)', fieldKey: SortingFieldKey.name, order: SortingOrder.asc },
  { value: 'File name (Z-A)', fieldKey: SortingFieldKey.name, order: SortingOrder.desc },
  { value: 'File type (A-Z)', fieldKey: SortingFieldKey.extension, order: SortingOrder.asc },
  { value: 'File type (Z-A)', fieldKey: SortingFieldKey.extension, order: SortingOrder.desc },
  { value: 'New first', fieldKey: SortingFieldKey.created_at, order: SortingOrder.desc },
  { value: 'Old first', fieldKey: SortingFieldKey.created_at, order: SortingOrder.asc },
];

export const Sorting = () => {
  const dispatch = useDispatch();
  const order = useSelector(getSortingOrder);
  const fieldKey = useSelector(getSortingFieldKey);
  const option = OPTIONS.find((item) => item.fieldKey === fieldKey && item.order === order);
  const searchOptions = useSelector(getSearchOptions);
  const uploadData = useSelector(getSearchUploadData);

  const selectProps: ComponentProps<typeof Select> =
    searchOptions.searchWithAi || uploadData
      ? {
          disabled: true,
          options: [{ value: 'AI relevant' }],
          value: 'AI relevant',
        }
      : {
          options: OPTIONS,
          value: option?.value,
          onChange: (value) => {
            const option = OPTIONS.find((item) => item.value === value);
            if (option) {
              dispatch(
                sortingActions.sortingChanged({ order: option.order, fieldKey: option.fieldKey }),
              );
            }
          },
        };

  return (
    <Select className="al-sorting" size="small" popupMatchSelectWidth={false} {...selectProps} />
  );
};
